import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedServiceAdapter } from './linkedservice.adapter';
import { passwordOrAKVtoSecretBase, secretBaseToPasswordOrAKV } from './azure-key-vault.util';
import { AzureSynapseAnalyticsWorkspaceLinkedService } from 'app/model/linkedservice/azure-synapse-analytics.linkedservice';
import { restAuthTypes } from 'shell-models-lib';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AzureSynapseAnalyticsWorkspaceLinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*',
            typeProperties: {
                workspaceName: '*',
                username: '*',
                userTenant: '*',
                password: 'secret',
                authenticationType: '*'
            },
            parameters: '*'
        }
    }
})

export class AzureSynapseAnalyticsLinkedServiceAdapter extends LinkedServiceAdapter<AzureSynapseAnalyticsWorkspaceLinkedService> {

    protected modelConstructor(): new () => AzureSynapseAnalyticsWorkspaceLinkedService {
        return AzureSynapseAnalyticsWorkspaceLinkedService;
    }

    protected model(): IModel {
        return AzureSynapseAnalyticsWorkspaceLinkedService.MODEL;
    }

    protected async propertiesToResourceAsync(linkedService: AzureSynapseAnalyticsWorkspaceLinkedService, linkedServiceResource: Model.LinkedServiceResource): Promise<Model.LinkedServiceResource> {
        const properties = this.properties(linkedServiceResource) as Model.AzureSynapseAnalyticsLinkedService;
        properties.type = Metamodel.modelFor(AzureSynapseAnalyticsWorkspaceLinkedService).name;
        properties.typeProperties = {
            workspaceName: this.valueToResource(linkedService, AzureSynapseAnalyticsWorkspaceLinkedService.WORKSPACE_NAME)
        };
        if (linkedService.servicePrincipalId) {
            properties.typeProperties.servicePrincipalId = linkedService.servicePrincipalId;
            properties.typeProperties.servicePrincipalKey = passwordOrAKVtoSecretBase(linkedService.servicePrincipalKey, this.context);
            properties.typeProperties.tenant = linkedService.tenant;
            properties.typeProperties.authenticationType = restAuthTypes.AadServicePrincipal;
        } else {
            properties.typeProperties.authenticationType = restAuthTypes.ManagedServiceIdentity;
        }
        return linkedServiceResource;
    }

    protected async propertiesToModelAsync(linkedServiceResource: Model.LinkedServiceResource, linkedService: AzureSynapseAnalyticsWorkspaceLinkedService): Promise<AzureSynapseAnalyticsWorkspaceLinkedService> {
        const properties = linkedServiceResource.properties as Model.AzureSynapseAnalyticsLinkedService;

        linkedService.workspaceName = properties.typeProperties.workspaceName;

        switch (properties.typeProperties.authenticationType) {
            case restAuthTypes.AadServicePrincipal:
                linkedService.authenticationType = restAuthTypes.AadServicePrincipal;
                linkedService.servicePrincipalId = properties.typeProperties.servicePrincipalId;
                linkedService.tenant = properties.typeProperties.tenant;
                linkedService.servicePrincipalKey = secretBaseToPasswordOrAKV(properties.typeProperties.servicePrincipalKey, true, this.context);
                break;
            case restAuthTypes.ManagedServiceIdentity:
                linkedService.authenticationType = restAuthTypes.ManagedServiceIdentity;
                break;
            default:
                break;
        }

        return linkedService;
    }
}
